<template>
  <div class="accounts-card">

    <div class="media" v-if="!hideMedia">
      <heart-beat>
        <img src="../../../../../assets/loader-white.png"
           alt="q-cumber"
           :class="{animated: loading}"/>
      </heart-beat>
    </div>

    <div class="content">
      <h3 v-if="error" class="text-xs-center step-error bold py-3" v-html="error"></h3>
      <h3 v-else-if="description" class="text-xs-center description py-3" v-html="description" ref="descriptionref"></h3>
      <slot></slot>
    </div>

  </div>
</template>

<script>
import GettextMixin from '@paiuolo/pai-vue-gettext/mixins/GettextMixin'

import HeartBeat from '../../../../animations/HeartBeat'


export default {
  name: 'AccountsCard',
  mixins: [
    GettextMixin
  ],
  components: {
    HeartBeat
  },
  data () {
    return {
    }
  },
  props: {
    description: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    hideMedia: {
      type: Boolean,
      default: false
    },
    fillWidth: {
      type: Boolean,
      default: false
    },
    linkClickAsEvent: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    if (this.linkClickAsEvent && this.$refs.descriptionref) {
      let children = this.$refs.descriptionref.children
      for (let i = 0; i < children.length; i++) {
        let nodeName = children[i].nodeName
        if (nodeName === 'A') {
          children[i].addEventListener('click', (event) => {
            event.preventDefault()
            this.$emit('link-clicked', event)
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../../../../scss/accounts.theme";

.accounts-card {
  width: 264px;
  margin: auto;
  border-radius: 4px;
  color: $on-primary;
  text-align: center;
  position: relative;
  z-index: 4;

  .media {
    img {
      display: block;
      width: 140px;
      height: 126px;
      margin: 24px auto
    }
  }
  .description {
    letter-spacing: normal;
    /* font-weight: normal*/
  }

  a {
    font-weight: bold;
    color: #e20000;
  }

  .step-error {
    color: #e20000;
    font-weight: 600;

    a {
      color: #fff;
    }
  }
  .content {
    h3 {
      margin: 20px 0 16px;
    }
  }

  /* IE11 (shit) patch */
  /*@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    margin: 0;
  }*/
}

.accounts-card.fillWidth {
  width: auto;
}

</style>
